


























































































































import {Component, Vue, Watch} from "vue-property-decorator";
import Footer from "@/views/frame/Footer.vue";
import Header from "@/views/frame/Header.vue";
// import locationImg from "../../../static/compress-img/public/aboutUs/scatter_offline.png"

@Component({
  components: {
    Footer, Header
  },
})
export default class AboutUs extends Vue {
  public cerList = [
    {
      imgPath:require('../../../static/compress-img/public/aboutUs/certificate/z2.png'),
      name:'ISO27001'
    },
    {
      imgPath:require('../../../static/compress-img/public/aboutUs/certificate/z1.png'),
      name:'ISO20000'
    },
    {
      imgPath:require('../../../static/compress-img/public/aboutUs/certificate/z3.png'),
      name:'国家高新技术企业'
    },
    {
      imgPath:require('../../../static/compress-img/public/aboutUs/certificate/z6.png'),
      name:'双软企业'
    },
    {
      imgPath:require('../../../static/compress-img/public/aboutUs/certificate/z4.png'),
      name:'ITSS三级'
    },
    {
      imgPath:require('../../../static/compress-img/public/aboutUs/certificate/z5.png'),
      name:'CMMI三级'
    },

  ]
  public locationImg = require('../../../static/compress-img/public/aboutUs/scatter_offline.png')
  map1: any;
  // BD-09 → GCJ-02 坐标转换
  bd09ToGcj02(bdLng: number, bdLat: number) {
    const x = bdLng - 0.0065;
    const y = bdLat - 0.006;
    const z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * Math.PI * 3000 / 180);
    const theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * Math.PI * 3000 / 180);
    return { lng: z * Math.cos(theta), lat: z * Math.sin(theta) };
  }
  mounted(){
    const gcj = this.bd09ToGcj02(119.487873, 32.139625);
    this.map1 = new TMap.Map(document.getElementById("map1"), {
      center: new TMap.LatLng(gcj.lat, gcj.lng),
      zoom: 19,
      scrollWheel: true,
    });
    window['map1'] = this.map1;
    this.addMarkerPoint(new TMap.LatLng(gcj.lat, gcj.lng), '江苏斯诺物联科技有限公司', this.locationImg, this.map1);
  }
  addMarkerPoint(position: any, labelText: string, iconUrl: string, map: any) {
    new TMap.MultiMarker({
      map: map,
      styles: {
        marker: new TMap.MarkerStyle({
          width: 30,
          height: 33,
          src: iconUrl,
          anchor: { x: 15, y: 33 },
        }),
      },
      geometries: [{
        id: 'company',
        styleId: 'marker',
        position: position,
      }],
    });
    const infoWin = new TMap.InfoWindow({
      map: map,
      position: position,
      offset: { x: 0, y: -30 },
      enableCustom: true,
      content: `<div style="background:#2A93FF;color:#efefef;font-size:14px;padding:0 10px;border-radius:5px;height:36px;line-height:36px;max-width:300px;text-align:center;white-space:nowrap;">${labelText}</div>`,
    });
    infoWin.open();
  }

}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/public/AboutUs.vue